import { StateStream } from '@cgs/wge';
import { SpinResponse } from '@cgs/data-access';
import { BaseStore } from '@cgs/shared';

export const SLOT_MACHINE_STORE_TOKEN = Symbol('SLOT_MACHINE_STORE_TOKEN');

export class SlotMachineStore extends BaseStore<SpinResponse> {
  private readonly _errorStream: StateStream<Error | null> = new StateStream<Error | null>(null);

  constructor(initialState?: SpinResponse) {
    super(initialState || new SpinResponse());
  }

  public override set state(data: SpinResponse) {
    super.state = data;
    console.log('SpinResponse:', data);
  }

  public override get state(): SpinResponse {
    return this._stream.state;
  }

  public get error(): Error | null {
    return this._errorStream.state;
  }

  public set error(error: Error | null) {
    this._errorStream.emit(error);
  }

  public get errorStream(): StateStream<Error | null> {
    return this._errorStream;
  }
}
